(function(){
  document.querySelectorAll('a[href^="#kalma-"]').forEach(function(a){
    if(a.dataset.kalmaBound) return;
    a.dataset.kalmaBound = '1';
    a.addEventListener('click', function(e){
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if(target){
        e.preventDefault();
        target.scrollIntoView({behavior:'smooth', block:'start'});
      }
    });
  });

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.reveal:not([data-kalma-reveal-bound])');
  if(reduceMotion || !('IntersectionObserver' in window)){
    els.forEach(function(el){ el.dataset.kalmaRevealBound = '1'; el.classList.add('in'); });
    return;
  }
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.isIntersecting){
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, {threshold:0.05, rootMargin:'0px 0px -40px 0px'});
  els.forEach(function(el){
    el.dataset.kalmaRevealBound = '1';
    io.observe(el);
  });
  setTimeout(function(){
    els.forEach(function(el){ el.classList.add('in'); });
  }, 4000);
})();
